const { DOMAIN } = process.env;

export const getCookie = name => {
	const cookieArray = document.cookie.split(';');

	for (let i = 0; i < cookieArray.length; i += 1) {
		const [cookieKey, cookieValue] = cookieArray[i].split('=');

		if (cookieKey.trim() === name) {
			return cookieValue.trim();
		}
	}

	return null;
};

export const deleteCookie = name => {
	document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${DOMAIN};`;
};
